import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/layouts/authStyle.js";
import { Route, Switch } from "react-router-dom";
import WebCheckIn from "pages/module/flight/webCheckIn";
import AirlineContact from "pages/module/flight/airlineContact";
import PayuCard from "pages/module/paymentgateway/PayuCheckout/PayuCard";

const useStyles = makeStyles(styles);

export default function LandingPageLayout(props) {console.log("props.appconst", props.appconst)
  const classes = useStyles();
  const [isLoading, setIsLoading] = React.useState(false);

  return (
    <div
      className={classes.wrapper}
      style={{ display: "flex", flexDirection: "column" }}
    >
      <props.appconst.homePageNavbar isloading={isLoading} appconst={props.appconst}/>
      <Switch>
        <Route path="/aboutus">
          <props.appconst.aboutUs/>
        </Route>
        <Route path="/contactus">
          <props.appconst.contactUs/>
        </Route>
        <Route path="/termsandconditions">
          <props.appconst.termsAndConditions/>
        </Route>
        <Route path="/privacypolicy">
          <props.appconst.privacyPolicy/>
        </Route>
        <Route path="/webcheckin" component={WebCheckIn} />
        <Route path="/airlinecontacts" component={AirlineContact} />
        <Route path="/distributor">
          <props.appconst.landingPageBase appconst={props.appconst}/>
        </Route>
        <Route>
          <props.appconst.landingPageBase appconst={props.appconst}/>
        </Route>
      </Switch>
      <props.appconst.pageFooter appconst={props.appconst}/>
    </div>
  );
}
